import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import download from './views/download';
import news from './views/news';
import about from './views/about';
import details from './views/details';
import beibeile from './views/BeibeileIndex'

Vue.use(Router)

export default new Router({
    routes: [
        // { path: '/', name: 'index', component: download },
        { path: '/index', name: 'download', component: download },
        { path: '/beibeile', name: 'beibeile', component: beibeile },
        { path: '/news',  name: 'Header', component: news},
        { path: '/about',  name: 'about', component: about},
        { path: '/news/details',  name: 'details', component: details},
        // { path: '*', redirect: '/news/details' }
        { path: '*', redirect: '/index' },
    ]
})